import { ComponentDescriptor, ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseState } from 'app/area/case/types-store';
import { getMenuAccess } from 'app/shell/selectors';

export const manageOptions = (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const hostprops = uiEngineProps.hostProps();
  const canCreate = getMenuAccess(hostprops.sharedState.access).codetableAdministration;
  const descriptor: ComponentDescriptor = uiEngineProps.componentDescriptor;

  return {
    manageOptions: {create: canCreate, codetableId: descriptor.codetable}
  };
};

export interface ManageOptionsParams {
  create: boolean;
  codetableId: number;  
}
